// https://github.com/ljharb/proposal-global
var $export = require('./_export');

$export($export.S, 'System', {global: require('./_global')});


//////////////////
// WEBPACK FOOTER
// /Volumes/Data HD/Git-UI/uikit-fullscreen/~/babel-polyfill/~/core-js/modules/es7.system.global.js
// module id = 303
// module chunks = 0